import { List, Map } from 'immutable';

const mapPermissions = function (user, roles) {
    let permissionsMap = Map();
    user.getIn([ 'data', 'permissionGrants' ], List()).forEach(p => {
        if (p) {
            permissionsMap = permissionsMap.set(p.get('permission'), p);
        }
    });
    return permissionsMap;
};

export default function (func) {
    return (state, props) => ({
        permissions: mapPermissions(state.user, state.roles),
        ...func(state, props)
    });
}
